module.exports = __webpack_public_path__ + "fonts/rw-widgets-bc7c4a5.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-widgets/dist/fonts/rw-widgets.eot
// module id = 224
// module chunks = 6